/**
 * Cart upsell (Cecca) — dynamic recommendations + quick-add + slider arrows.
 *
 * Three delegated listeners on document (they survive Section Rendering
 * re-renders, which destroy element-bound listeners) plus a fetch cycle:
 *
 * 1. refreshUpsell(): reads #CartUpsellCecca placeholder (re-rendered with the
 *    cart, so data-product-id is always the freshest first line item), fetches
 *    the Product Recommendations API with section_id=cart-upsell-cecca, and
 *    injects the returned HTML. intent comes from data-intent (related →
 *    switch to complementary after Search & Discovery pairings are set).
 * 2. Quick-add: POST /cart/add.js with sections → cartDrawer.renderContents
 *    → refreshUpsell. Same flow as Dawn's product-form.js.
 * 3. Dawn pubsub: cartUpdate fires on every add/quantity change from anywhere
 *    in the theme → refreshUpsell (delayed so it runs after the re-render).
 *    NB: PUB_SUB_EVENTS is a top-level `const` in Dawn's pubsub.js — it lives
 *    in global SCOPE but is NOT a window property. Guarding on
 *    window.PUB_SUB_EVENTS silently skipped the subscription (that's why the
 *    upsell vanished on every quantity change). Resolve via scope, not window.
 * 4. window.CeccaCartUpsell.refresh(): public hook for custom add-to-cart
 *    flows (fps slider, bundle builder) that re-render the drawer WITHOUT
 *    publishing cartUpdate — they must call this after renderContents, since
 *    the re-render brings back an empty placeholder.
 */
(function () {
  var refreshTimer = null;

  function refreshUpsell() {
    var placeholder = document.getElementById('CartUpsellCecca');
    if (!placeholder) return;

    var productId = placeholder.dataset.productId;
    var baseUrl = placeholder.dataset.url;
    var intent = placeholder.dataset.intent || 'related';

    if (!productId || !baseUrl) {
      placeholder.innerHTML = '';
      return;
    }

    var url =
      baseUrl +
      '?section_id=cart-upsell-cecca&product_id=' +
      productId +
      '&limit=6&intent=' +
      intent;

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var block = doc.querySelector('.cart-upsell-cecca');
        if (block && block.querySelector('.cart-upsell-cecca__card')) {
          placeholder.innerHTML = block.outerHTML;
        } else {
          placeholder.innerHTML = '';
        }
      })
      .catch(function (error) {
        console.error('[cart-upsell-cecca] recommendations fetch', error);
      });
  }

  function scheduleRefresh() {
    // Delay lets Dawn finish swapping the drawer HTML first,
    // so we inject into the NEW placeholder, not the one being replaced.
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshUpsell, 200);
  }

  // --- Quick-add ---
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.cart-upsell-cecca__add');
    if (!btn) return;

    var card = btn.closest('.cart-upsell-cecca__card');
    var variantField = card && card.querySelector('.cart-upsell-cecca__variant');
    var cartDrawer = document.querySelector('cart-drawer');
    if (!variantField || !cartDrawer) return;

    btn.disabled = true;

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        id: Number(variantField.value),
        quantity: 1,
        sections: cartDrawer.getSectionsToRender().map(function (s) {
          return s.id;
        }),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (state) {
        if (state.status) {
          throw new Error(state.description || 'Impossibile aggiungere al carrello');
        }
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(state);
        scheduleRefresh();
      })
      .catch(function (error) {
        console.error('[cart-upsell-cecca] add', error);
        btn.disabled = false;
      });
  });

  // --- Slider arrows ---
  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('.cart-upsell-cecca__arrow');
    if (!arrow) return;
    var scroller = arrow
      .closest('.cart-upsell-cecca')
      .querySelector('.cart-upsell-cecca__scroller');
    if (!scroller) return;
    var dir = arrow.dataset.dir === 'next' ? 1 : -1;
    scroller.scrollBy({ left: dir * scroller.clientWidth * 0.85, behavior: 'smooth' });
  });

  // --- React to any cart change anywhere in the theme (see header, point 3) ---
  var pubSubEvents = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : window.PUB_SUB_EVENTS;
  var subscribeFn = typeof subscribe !== 'undefined' ? subscribe : window.subscribe;
  if (subscribeFn && pubSubEvents && pubSubEvents.cartUpdate) {
    subscribeFn(pubSubEvents.cartUpdate, scheduleRefresh);
  }

  // Public hook (see file header, point 4).
  window.CeccaCartUpsell = { refresh: scheduleRefresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshUpsell);
  } else {
    refreshUpsell();
  }
})();
